<template>
    <div class="overlay">
        <header class="hero-container">
            <div class="text-center">
                <nav>
                    <span class="edition-badge">QUINTA EDICIÓN</span>
                </nav>

                <div class="hero-content mt-4">
                    <h1 class="brand-title">XHiDENXi</h1>
                    <h2 class="main-event-title">CARRERA DE <br> OBSTACULOS</h2>
                </div>

                <div class="overlay2">
                    <div class="date-pill">12 • JUL • 2026</div>
                </div>
            </div>
        </header>

        <CardRaceInfo
            id="informacion"
            titulo="XHIDENXHI OCR 2026"
            estado="Estado de México"
            color-estado="#000"
            fecha="Domingo 12 de julio de 2026"
            sede="Canalejas, Jilotepec"
            hora="8:00 am"
            distancia="7 Km - 25 Obstaculos"
            :banner="bannerCarrera"
            :action-click="irARegistro"
            :inscripcion-cerrada="inscripcionesCerradas"
        />

        <!-- Información general -->
        <section class="info-section py-5">
            <div class="container">
                <div class="text-center mb-5">
                    <img src="@/assets/images/logo_principal.png" class="imgBanner img-fluid" alt="logo" width="180">
                </div>

                <p class="mission-text">
                    ¡Prepárate para una experiencia extrema entre naturaleza, lodo, fuerza y resistencia!
                </p>
            </div>
        </section>

        <!-- Ubicación -->
         <section class="location-container">
            <div class="content-wrapper">
                <div class="info-side">
                    <h2 class="title">¿DÓNDE SERÁ EL RETO?</h2>

                    <div class="location-details">
                        <div class="detail-group">
                            <div>
                                <h3>FECHA</h3>
                                <p>Domingo 12 de Julio, 2026</p>
                            </div>
                        </div>

                        <div class="detail-group">
                            <div>
                                <h3>UBICACIÓN</h3>
                                <p>Rancho Don Mundo</p>
                                <p class="reference">(A 200 metros de la entrada al Parque El Llano)</p>
                            </div>
                        </div>
                    </div>

                    <a href="https://maps.app.goo.gl/nk7yrNCB1zRWMbG89"
                        target="_blank" class="btn-maps">
                        ¿CÓMO LLEGAR?
                    </a>
                </div>

                <div class="map-side">
                    <div class="map-wrapper">
                        <!-- Aquí colocarás la captura del mapa -->
                        <img src="@/assets/images/mapaRancho.png" alt="Mapa Rancho Don Mundo" class="map-image" />
                        <div class="map-overlay" @click="openGoogleMaps">
                            <span>VER EN GOOGLE MAPS</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Ruta y Obstáculos -->
         <section class="details-container">
            <!-- Resumen de Ruta -->
            <div class="route-stats">
                <div class="stat-box">
                    <h3>7 KILÓMETROS</h3>
                </div>
                <div class="stat-box">
                    <h3>25 OBSTÁCULOS</h3>
                </div>
                <p class="route-desc">Supera una ruta diseñada para poner a prueba cuerpo y mente.</p>
            </div>

            <!-- Sección de Obstáculos -->
            <div class="obstacles-section">
                <h2 class="title-accent">LO QUE TE ESPERA 🪵</h2>
                <div class="obstacles-chips">
                    <span v-for="obs in obstacles" :key="obs" class="chip">
                        {{ obs }}
                    </span>
                    <span class="chip more">¡Y MUCHOS MÁS!</span>
                </div>
            </div>

            <div class="dual-column">
                <!-- Horarios y Categorías -->
                <div class="info-card">
                    <h2 class="title-accent">🕒 HORARIOS DE SALIDA</h2>
                    <div class="schedule-list">
                        <div class="schedule-item">
                            <span class="label">FEMENIL LIBRE</span>
                            <span class="time">8:00 AM</span>
                        </div>
                        <div class="schedule-item">
                            <span class="label">VARONIL LIBRE</span>
                            <span class="time">8:30 AM</span>
                        </div>
                        <div class="schedule-item highlight">
                            <span class="label">PAREJAS</span>
                            <span class="time">9:30 AM</span>
                        </div>
                    </div>

                    <div class="category-notes">
                        <h3>🏆 CATEGORÍAS</h3>
                        <ul>
                            <li>Libre Femenil</li>
                            <li>Libre Varonil</li>
                            <li>Parejas Mixtas (1H + 1M)</li>
                        </ul>
                        <div class="warning-box">
                            <p>📌 En parejas deberán completar la ruta y cruzar meta juntos.</p>
                            <p>📌 Parejas del mismo sexo participan en modalidad <strong>recreativa</strong> (sin
                                premiación).</p>
                        </div>
                    </div>
                </div>

                <!-- Premiación -->
                <div class="prizes-card">
                    <div class="prize-badge">
                        <span class="prize-total">💰 $10,000</span>
                        <span class="prize-label">PESOS EN PREMIOS</span>
                    </div>
                    <div class="podium-info">
                        <h3>🥇🥈🥉 PREMIACIÓN OFICIAL</h3>
                        <p>Para los 3 primeros lugares de categorías individuales y las 3 primeras parejas mixtas.</p>
                        <div class="divider"></div>
                        <p class="distribution-note">Repartidos entre las categorías oficiales del evento.</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Fases de inscripción -->
        <section class="registration-container">
            <div class="container"> <!-- Cambiado a container de Bootstrap -->
                <h2 class="section-title-2026">FASES DE REGISTRO</h2>

                <div class="row g-4 mb-5"> <!-- g-4 para el gap entre columnas de Bootstrap -->
                    <!-- Individuales -->
                    <div class="col-md-6">
                        <div class="pricing-card main-card h-100">
                            <h3 class="card-category text-center">INDIVIDUAL</h3>
                            <div class="phases-list">
                                <div class="phase-item current">
                                    <div class="phase-indicator status-green"></div>
                                    <div class="phase-info">
                                        <span class="phase-name">FASE 1</span>
                                        <span class="phase-date">12 Mayo - 31 Mayo</span>
                                    </div>
                                    <div class="phase-price">$400</div>
                                </div>
                                <div class="phase-item">
                                    <div class="phase-indicator status-yellow"></div>
                                    <div class="phase-info">
                                        <span class="phase-name">FASE 2</span>
                                        <span class="phase-date">1 Junio - 25 Junio</span>
                                    </div>
                                    <div class="phase-price">$470</div>
                                </div>
                                <div class="phase-item">
                                    <div class="phase-indicator status-red"></div>
                                    <div class="phase-info">
                                        <span class="phase-name">FASE 3</span>
                                        <span class="phase-date">26 Junio - 10 Julio</span>
                                    </div>
                                    <div class="phase-price">$550</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Parejas -->
                    <div class="col-md-6">
                        <div class="pricing-card team-card h-100">
                            <div class="badge-promo">EQUIPO</div>
                            <h3 class="card-category">PAREJAS</h3>
                            <div class="price-container">
                                <span class="currency">$</span>
                                <span class="amount">900</span>
                                <span class="per-team">POR EQUIPO</span>
                            </div>
                            <p class="promo-text">¡Vence el reto acompañado!</p>
                            <button class="btn-register" @click="irARegistro" :disabled="inscripcionesCerradas">
                                {{ inscripcionesCerradas ? 'REGISTRO FINALIZADO' : 'INSCRIBIRME' }}
                            </button>
                        </div>
                    </div>

                    <!-- Kit de Competidor (Fila completa) -->
                    <div class="col-12 mt-4">
                        <div class="kit-section">
                            <h3 class="kit-title">TU INSCRIPCIÓN INCLUYE</h3>
                            <div class="kit-row">
                                <div v-for="item in kitItems" :key="item.text" class="kit-pill">
                                    <span class="kit-icon">{{ item.icon }}</span>
                                    <span class="kit-text">{{ item.text }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Equipamiento Oficial -->
                    <div class="col-12 mt-5">
                        <div class="d-flex justify-content-center">
                            <div class="kit-showcase-card">

                                <div class="kit-info">
                                    <span class="kit-tag">INCLUIDO EN TU INSCRIPCIÓN</span>

                                    <h4 class="kit-subtitle">
                                        EQUIPAMIENTO OFICIAL
                                    </h4>

                                    <h2 class="kit-main-text">
                                        PLAYERA & MEDALLA
                                    </h2>
                                </div>

                                <div class="image-container-full">
                                    <img src="@/assets/images/2026/playera-oficial.jpeg" alt="Playera y Medalla Oficial"
                                        class="kit-img-single" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Formas de Pago -->
        <div class="container pb-5">
            <div class="text-center mt-5">
                <h4 class="text-xhidenxi fw-black mb-0">INSCRIPCIONES</h4>
                <p class="text-xhidenxi-sub small text-uppercase letter-spacing-2">Elige tu método preferido</p>
            </div>

            <section class="mt-4 px-lg-0 px-3">
                <div class="row g-4 justify-content-center">

                    <div class="col-lg-4 col-md-6">
                        <div class="card-metodo-pago h-100 shadow-sm">
                            <div class="badge-tipo">PRESENCIAL</div>
                            <div class="text-center mb-4 mt-2">
                                <img src="@/assets/images/logo_principal.png" class="logo-presencial" alt="logo">
                            </div>
                            <div class="metodo-body text-center">
                                <h3 class="h5 fw-black mb-1">Gimnasio El Terreno</h3>
                                <p class="text-muted mb-2 small text-uppercase">Lunes a viernes</p>
                                <h5 class="fw-black text-dark bg-light py-2 rounded-3">5:00 PM a 8:00 PM</h5>
                                <p class="mt-3 small text-muted">Inscripción directa en el gimnasio.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="card-metodo-pago h-100 highlight shadow">
                            <div class="badge-tipo bg-dark text-white">EN LÍNEA</div>
                            <div class="metodo-body">
                                <h3 class="h5 fw-black mb-3 text-center">Transferencia CLABE</h3>
                                <div class="clabe-box mb-3 border-dark">
                                    <code class="fs-6 text-dark fw-bold">728969000028945078</code>
                                </div>
                                <div class="row mb-3 px-2">
                                    <div class="col-6">
                                        <span class="label-pago">Banco</span>
                                        <p class="mb-0 fw-bold small">Spin por OXXO</p>
                                    </div>
                                    <div class="col-6 text-end">
                                        <span class="label-pago">Beneficiario</span>
                                        <p class="mb-0 fw-bold small">Gimnasio El Terreno</p>
                                    </div>
                                </div>
                                <div class="wa-notif p-3 rounded-3 text-center">
                                    <p class="small fw-bold mb-2">1. Inicia tu proceso de registro aquí:</p>
                                    <button class="btn btn-dark w-100 mb-3 py-2 fw-black shadow-sm" @click="irARegistro"
                                        :disabled="inscripcionesCerradas">
                                        {{ inscripcionesCerradas ? 'REGISTRO FINALIZADO' : 'INSCRIBIRME' }}
                                    </button>

                                    <p class="small text-muted mb-0">
                                        <strong>2.</strong> Una vez termiando, manda tu captura de la confirmación de
                                        registro y comprobante al
                                        <a href="https://wa.me/525540861907" class="text-confirmacion">
                                            <strong>55 4086 61907</strong>
                                        </a>
                                        para validar tu participación.
                                    </p>
                                </div>
                                <div class="action-box p-3 rounded-4 bg-light text-center">
                                    <p class="x-small text-muted mb-0">Sube tu comprobante al finalizar el registro.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="card-metodo-pago h-100 border-oxxo shadow-sm">
                            <div class="badge-tipo bg-oxxo text-white">EFECTIVO OXXO</div>
                            <div class="metodo-body">
                                <h3 class="h5 fw-black mb-3 text-center">Pago Directo en OXXO</h3>

                                <div class="card-number-box mb-3">
                                    <span class="label-pago text-center w-100 mb-1">Número para Deposito</span>
                                    <div
                                        class="d-flex justify-content-center align-items-center gap-2 py-2 bg-white rounded-3 border">
                                        <code class="fs-5 text-dark fw-black">2242 1704 2012 2648</code>
                                    </div>
                                </div>

                                <div class="instruction-step mb-3 d-flex gap-2 align-items-start">
                                    <div class="step-num">1</div>
                                    <p class="small mb-0">Realiza tu pago en caja y <strong>guarda tu ticket</strong>.
                                    </p>
                                </div>

                                <div class="instruction-step mb-4 d-flex gap-2 align-items-start">
                                    <div class="step-num">2</div>
                                    <p class="small mb-0">Inicia tu registro en el botón de abajo y <strong>carga la
                                            foto de tu ticket</strong>.</p>
                                </div>

                                <button class="btn btn-dark w-100 mb-3 py-2 fw-black shadow-sm" @click="irARegistro"
                                    :disabled="inscripcionesCerradas">
                                    {{ inscripcionesCerradas ? 'REGISTRO FINALIZADO' : 'INSCRIBIRME' }}
                                </button>

                                <div class="instruction-step mb-4 d-flex gap-2 align-items-start">
                                    <div class="step-num">3</div>
                                    <p class="small mb-0">
                                        Una vez termiando, manda tu captura de la confirmación de
                                        registro y comprobante al
                                        <a href="https://wa.me/525540861907" class="text-confirmacion">
                                            <strong>55 4086 61907</strong>
                                        </a>
                                        para validar tu participación.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import router from '@/router'
import CardRaceInfo from '@/components/CardRaceInfo.vue'
import bannerCarrera from '@/assets/images/2026/banner_co_2026.jpeg'

const kitItems = [
  { icon: '🎽', text: 'Playera oficial' },
  { icon: '🏅', text: 'Medalla Finisher' },
  { icon: '🔢', text: 'Número de competidor' },
  { icon: '🚑', text: 'Servicio médico básico' },
  { icon: '📸', text: 'Flyer digital de presentación' },
  { icon: '🌲', text: 'Acceso a ruta oficial' }
]

const obstacles = [
  '🧗 Escalada de cuerda', '⛰ Bordos naturales',
  '🧱 Muros', '💪 Pasamanos',
  '🪖 Arrastre militar', '🛞 Fosa de llantas'
]

const FECHA_LIMITE = new Date('2026-07-11T23:00:00')
const ahora = ref(new Date())

const inscripcionesCerradas = computed(() => {
  return ahora.value >= FECHA_LIMITE
})

let timer
onMounted(() => {
  timer = setInterval(() => {
    ahora.value = new Date()
  }, 60000)
})

onUnmounted(() => {
  clearInterval(timer)
})

const irARegistro = () => {
  if (inscripcionesCerradas.value) return
  router.push('/registro-obstaculos-2026')
}

const openGoogleMaps = () => {
  window.open('https://maps.app.goo.gl/nk7yrNCB1zRWMbG89', '_blank')
}
</script>

<style setup>
.hero-container {
  background-size: cover;
  background-position: center;
  color: #ffffff;
}

.overlay {
  background: linear-gradient(180deg, rgba(26, 62, 51, 0.8), rgba(0,0,0,0.9));
  min-height: 100vh;
  padding: 2rem 0;
  align-items: center;
  justify-content: center;
  margin-bottom: -50px;
}

.overlay2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
  text-align: center;
}

.edition-badge {
  background-color: #1a1a1a;
  padding: 5px 20px;
  border-radius: 20px;
  font-size: 0.8rem;
  letter-spacing: 2px;
  margin-bottom: 2rem;
  font-family: 'Inter', sans-serif;
}

.brand-title {
  font-size: 2.5rem;
  letter-spacing: 8px;
  margin-bottom: 0.5rem;
  font-weight: 300;
  font-family: 'Inter', sans-serif;
}

.main-event-title {
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: 900;
  line-height: 0.9;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  font-family: 'Inter', sans-serif;
}

.banner-date {
    color: #000;
}

.fw-black { font-weight: 900; }
.letter-spacing-2 { letter-spacing: 2px; }
.text-lime { color: #e1f5d4; }
.bg-lime-soft { background-color: #f9fbf8; }

.imgBanner {
  display: block;
  margin: 0 auto;
  max-width: 180px;
}

.mission-text {
  margin-top: 1rem;
  font-weight: 300;
  letter-spacing: 1px;
  font-family: 'Inter', sans-serif;
  color: #ffffff;
  text-align: center;
}

.date-pill {
  border: 2px solid #ffffff;
  padding: 8px 30px;
  border-radius: 12px;
  font-weight: bold;
  letter-spacing: 3px;
}

/* Fases de inscripción */
/* Contenedor General */
.registration-container {
  padding: 80px 0;
  background-color: #f8faf9;
  font-family: 'Inter', sans-serif;
}

.section-title-2026 {
  text-align: center;
  font-size: 2.8rem;
  font-weight: 900;
  letter-spacing: 3px;
  margin-bottom: 50px;
  color: #2d3e33; /* Verde bosque del banner */
}

/* Tarjetas (Sin grid manual, Bootstrap maneja el layout) */
.pricing-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.05);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.05);
  transition: transform 0.3s ease;
}

.card-category {
  font-size: 1.6rem;
  font-weight: 900;
  margin-bottom: 25px;
  letter-spacing: 1px;
}

/* Fases Individuales */
.phase-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
}
.phase-item:last-child { border: none; }

.phase-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 15px;
}
.status-green { background: #4ade80; box-shadow: 0 0 10px rgba(74, 222, 128, 0.4); }
.status-yellow { background: #facc15; }
.status-red { background: #f87171; }

.phase-info { flex-grow: 1; text-align: left; }
.phase-name { display: block; font-weight: 800; font-size: 1rem; }
.phase-date { font-size: 0.85rem; color: #666; }
.phase-price { font-weight: 900; font-size: 1.3rem; color: #2d3e33; }

/* Estilo Tarjeta Parejas (Acorde al Banner) */
.team-card {
  background: #2d3e33; /* Verde oscuro */
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.badge-promo {
  position: absolute;
  top: 25px;
  right: -35px;
  background: #facc15;
  color: #000;
  padding: 5px 45px;
  transform: rotate(45deg);
  font-weight: 900;
  font-size: 0.7rem;
}

.price-container { margin: 25px 0; }
.currency { font-size: 1.8rem; font-weight: 800; vertical-align: top; }
.amount { font-size: 4.5rem; font-weight: 900; line-height: 1; }
.per-team { display: block; font-size: 0.8rem; letter-spacing: 1px; opacity: 0.8; }

.btn-register {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: none;
  background: white;
  color: #2d3e33;
  font-weight: 900;
  margin-top: 20px;
  transition: all 0.3s ease;
}

/* Kit de Competidor (Fila completa con estilo Pill) */
.kit-section {
  background: white;
  border-radius: 24px;
  padding: 40px;
  border: 2px dashed #ccc;
}

.kit-title {
  text-align: center;
  font-weight: 900;
  margin-bottom: 30px;
  color: #2d3e33;
}

.kit-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
}

.kit-pill {
  background: #f0f4f2;
  padding: 12px 25px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #e0e0e0;
}

.kit-icon { font-size: 1.5rem; }
.kit-text { font-size: 0.95rem; font-weight: 700; color: #2d3e33; }

/* Responsive */
@media (max-width: 768px) {
  .section-title-2026 { font-size: 2.2rem; }
  .amount { font-size: 3.5rem; }
}

/* Métodos de inscripción */
.text-xhidenxi {
    color: #fff;
}

.text-xhidenxi-sub {
  font-size: 0.9rem;
  letter-spacing: 2px;
  color: #4ade80; /* Verde acento */
  margin: 0 0 5px 0;
}

.card-metodo-pago {
    background: #fff;
    border: 2px solid #f0f0f0;
    border-radius: 20px;
    padding: 30px 20px;
    position: relative;
    transition: all 0.3s ease;
}

.card-metodo-pago.highlight {
    border-color: #000;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.badge-tipo {
    position: absolute;
    top: -12px;
    left: 20px;
    background: #e1f5d4;
    color: #000;
    padding: 4px 15px;
    font-size: 0.7rem;
    font-weight: 900;
    border-radius: 50px;
    letter-spacing: 1px;
}

.logo-presencial {
    height: 60px;
    width: auto;
    object-fit: contain;
}

.clabe-box {
    background: #f8f8f8;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border: 1px dashed #ccc;
}

.label-pago {
    font-size: 0.7rem;
    color: #888;
    text-transform: uppercase;
    display: block;
    font-weight: bold;
}

.wa-notif {
    background: #e1f5d4;
    border: 1px solid #d4eec3;
}

.metodo-body h3 {
    text-transform: uppercase;
    letter-spacing: -0.5px;
}

.card-metodo-pago:hover {
    transform: translateY(-5px);
}

.bg-oxxo {
    background: #dd242c;
}

.border-oxxo {
    border: 2px solid #dd242c33 !important;
}

.border-oxxo-light {
    background-color: #fff5f5;
    border: 1px solid #ffeded;
}

.card-number-box {
    background-color: #fcfcfc;
    padding: 12px;
    border-radius: 12px;
}

.step-num {
    background: #000;
    color: #fff;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: 900;
    flex-shrink: 0;
}

.x-small {
    font-size: 0.7rem;
}

.wa-notif-small {
    transition: all 0.3s ease;
}

.wa-notif-small:hover {
    background-color: #e1f5d4;
    transform: scale(1.02);
}

.metodo-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

@media (max-width: 991px) {
    .card-metodo-pago {
        margin-bottom: 10px;
    }
}

/* Categorías */
.details-container {
  padding: 60px 20px;
  background: #ffffff;
  color: #2d3e33; /* El verde oscuro del banner */
  font-family: 'Inter', sans-serif;
}

/* Stats de Ruta */
.route-stats {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
}

.stat-box {
  display: flex;
  align-items: center;
  gap: 15px;
}

.stat-box h3 {
  font-size: 2.5rem;
  font-weight: 900;
  margin: 10px 0;
}

.route-desc {
  font-size: 1.1rem;
  opacity: 0.8;
  max-width: 400px;
  text-align: center;
}

/* Obstáculos */
.title-accent {
  font-weight: 900;
  letter-spacing: -1px;
  margin-bottom: 25px;
  text-transform: uppercase;
}

.obstacles-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-bottom: 60px;
}

.chip {
  background: #f0f4f1;
  padding: 10px 20px;
  border-radius: 50px;
  font-weight: 600;
  border: 1px solid #e0e0e0;
}

.chip.more {
  background: #2d3e33;
  color: white;
}

/* Layout de dos columnas */
.dual-column {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  max-width: 1100px;
  margin: 0 auto;
}

/* Tarjeta de Horarios */
.info-card {
  text-align: left;
  background: #f9f9f9;
  padding: 30px;
  border-radius: 20px;
}

.schedule-list {
  margin-bottom: 30px;
}

.schedule-item {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid #ddd;
  font-weight: 700;
}

.schedule-item.highlight {
  color: #2d3e33;
  border-bottom: 2px solid #2d3e33;
}

.warning-box {
  background: #fff3cd;
  padding: 15px;
  border-radius: 10px;
  font-size: 0.9rem;
  margin-top: 20px;
}

/* Tarjeta de Premios */
.prizes-card {
  background: linear-gradient(135deg, #2d3e33 0%, #1a1a1a 100%);
  color: white;
  padding: 40px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.prize-badge {
  background: #ffffff;
  color: #2d3e33;
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 25px;
  transform: rotate(-2deg);
}

.prize-total {
  display: block;
  font-size: 3rem;
  font-weight: 900;
}

.prize-label {
  font-weight: 700;
  letter-spacing: 2px;
}

.divider {
  width: 50px;
  height: 4px;
  background: #4ade80; /* El verde brillante de los acentos */
  margin: 20px auto;
}

/* Ubicacicón */
.location-container {
  padding: 80px 20px;
  background-color: #1a1a1a;
  color: white;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}

.content-wrapper {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
  gap: 40px;
  align-items: center;
}

/* Para pantallas grandes, restauramos las dos columnas */
@media (min-width: 992px) {
  .content-wrapper {
    grid-template-columns: 1fr 1fr;
    gap: 60px;
  }
}

.title {
  font-size: clamp(1.8rem, 5vw, 2.5rem);
  font-weight: 900;
  letter-spacing: 2px;
  margin-bottom: 30px;
  text-align: left;
}

.location-details {
  margin-bottom: 40px;
}

.detail-group {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  text-align: left;
}

.detail-group .icon {
  font-size: 2rem;
}

.detail-group h3 {
  font-size: 0.9rem;
  letter-spacing: 2px;
  color: #4ade80; /* Verde acento */
  margin: 0 0 5px 0;
}

.detail-group p {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
}

.reference {
  font-size: 1rem !important;
  font-weight: 400 !important;
  opacity: 0.7;
  margin-top: 5px !important;
}

/* Botón estilo OCR */
.btn-maps {
  display: inline-flex;
  align-items: center;
  gap: 15px;
  background-color: white;
  color: #1a1a1a;
  padding: 18px 35px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 900;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  border: 2px solid white;
}

.btn-maps:hover {
  background-color: transparent;
  color: white;
  transform: translateY(-5px);
}

/* Contenedor del Mapa */
.map-wrapper {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0,0,0,0.5);
  border: 5px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.map-image {
  width: 100%;
  height: 450px;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.map-wrapper:hover .map-image {
  transform: scale(1.05);
}

.map-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(45, 62, 51, 0.4); /* Overlay con el verde del bosque */
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.map-overlay span {
  background: white;
  color: black;
  padding: 10px 20px;
  border-radius: 50px;
  font-weight: 800;
  font-size: 0.8rem;
}

.map-wrapper:hover .map-overlay {
  opacity: 1;
}

@media (max-width: 768px) {
  .title { text-align: center; }
  .detail-group { justify-content: center; text-align: center; flex-direction: column; }
  .btn-maps { width: 100%; justify-content: center; }
}

.kit-showcase-card {
    max-width: 900px;
    margin: 0 auto;

    background: linear-gradient(
        180deg,
        #f8faf8 0%,
        #eef3ef 100%
    );

    border-radius: 32px;
    padding: 50px 40px 20px;

    border: 1px solid rgba(0, 0, 0, .05);

    text-align: center;
    overflow: hidden;
}

.kit-info {
    margin-bottom: 20px;
}

.kit-tag {
    display: inline-block;

    background: rgba(36, 54, 43, .08);
    color: #24362b;

    padding: 8px 14px;
    border-radius: 999px;

    font-size: .75rem;
    font-weight: 800;
    letter-spacing: 1px;

    margin-bottom: 18px;
}

.kit-subtitle {
    font-size: .9rem;
    font-weight: 800;
    letter-spacing: 3px;
    color: #6b7280;
    margin-bottom: 10px;
}

.kit-main-text {
    font-size: clamp(1.5rem, 3vw, 3rem);
    font-weight: 900;
    line-height: 1;

    color: #24362b;
    margin: 0;
}

.image-container-full {
    display: flex;
    justify-content: center;
    align-items: center;
}

.kit-img-single {
    width: 100%;
    max-width: 650px;

    object-fit: contain;

    filter: drop-shadow(
        0 25px 35px rgba(0,0,0,.15)
    );

    transition: .4s ease;

    border-radius: 10px;
}

.kit-showcase-card:hover .kit-img-single {
    transform: translateY(-8px);
}

@media (max-width: 768px) {

    .kit-showcase-card {
        padding: 35px 20px 10px;
        border-radius: 24px;
    }

    .kit-main-text {
        font-size: 2.4rem;
    }

    .kit-img-single {
        max-width: 100%;
    }
}
</style>
